import React from 'react';
import {StencilProvider} from '@amzn/stencil-react-components/context';
import defaultTheme from "@amzn/stencil-react-theme-default";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { PageHeader, PageHeaderLink} from '@amzn/stencil-react-components/page';
import { Col } from '@amzn/stencil-react-components/layout';
import { Text } from "@amzn/stencil-react-components/text";
import { store } from "src/state/store"
import { Provider } from "react-redux";

import { HomePage } from "src/components/pages/HomePage";
import { CreateEventModelPage } from "src/components/pages/CreateEventModelPage";
import { SelectEventModelPage } from "src/components/pages/SelectEventModelPage";
import { ManageEventModelPage } from "src/components/pages/manageEventModel/ManageEventModelPage";
import { ReplayEventModelPage } from "src/components/pages/ReplayEventModelPage";

import AuthenticatedRoute from 'src/auth/AuthenticatedRoute';
import { CommonConstants, PathNames } from 'src/constant/constants';

export class App extends React.Component {
  render() {
    return (
      <StencilProvider theme={defaultTheme}>
        <Provider store={store}>
          <Col>
            <PageHeader isFixed={true}>
              <PageHeaderLink href="/" paddingHorizontal={"0"}>
                <Text fontSize={"T400"} fontWeight={"bold"}>
                  {CommonConstants.PAGE_HEADER}
                </Text>
              </PageHeaderLink>
            </PageHeader>
            <Router basename='/ease-authoring'>
              <AuthenticatedRoute>
                <Switch>
                  <Route exact path={PathNames.CREATE_EVENT_MODELS_PAGE}>
                    <CreateEventModelPage />
                  </Route>
                  <Route exact path={`${PathNames.MANAGE_EVENT_MODELS_PAGE}/:eventModelName`}>
                    <ManageEventModelPage />
                  </Route>
                  <Route exact path={PathNames.MANAGE_EVENT_MODELS_PAGE}>
                    <SelectEventModelPage />
                  </Route>
                  <Route exact path={PathNames.REPLAY_FAILED_EVENTS_PAGE}>
                    <ReplayEventModelPage />
                  </Route>
                  <Route exact path="/">
                    <HomePage />
                  </Route>
                </Switch>
              </AuthenticatedRoute>
            </Router>
          </Col>
        </Provider>
      </StencilProvider>
    );
  }
}

export default App;
